import { toLogin } from '../utils/redirect';
import { ApiResponseError } from './ApiResponseError';

const UNAUTHORIZED_STATUS = 401;

export const handleApiResponse = (response: Response): void => {
  if (response.ok) {
    return;
  }

  if (response.status === UNAUTHORIZED_STATUS) {
    toLogin();
  }

  throw new ApiResponseError(response.status, response);
};
